import { useTranslation } from 'react-i18next';
import { languages, type LanguageCode } from '../lib/i18n';

function USFlag() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14">
      <rect width="20" height="14" fill="#B22234"/>
      <rect y="1.08" width="20" height="1.08" fill="white"/>
      <rect y="3.23" width="20" height="1.08" fill="white"/>
      <rect y="5.38" width="20" height="1.08" fill="white"/>
      <rect y="7.54" width="20" height="1.08" fill="white"/>
      <rect y="9.69" width="20" height="1.08" fill="white"/>
      <rect y="11.85" width="20" height="1.08" fill="white"/>
      <rect width="8" height="7.54" fill="#3C3B6E"/>
    </svg>
  );
}

function RUFlag() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14">
      <rect width="20" height="4.67" fill="white"/>
      <rect y="4.67" width="20" height="4.67" fill="#0039A6"/>
      <rect y="9.33" width="20" height="4.67" fill="#D52B1E"/>
    </svg>
  );
}

function ESFlag() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14">
      <rect width="20" height="14" fill="#AA151B"/>
      <rect y="3.5" width="20" height="7" fill="#F1BF00"/>
    </svg>
  );
}

const flagComponents: Record<LanguageCode, () => JSX.Element> = {
  en: USFlag,
  ru: RUFlag,
  es: ESFlag,
};

export function LanguageSelector() {
  const { i18n } = useTranslation();

  const handleChange = (code: LanguageCode) => {
    i18n.changeLanguage(code);
  };

  const currentLang = (i18n.language?.split('-')[0] || 'en') as LanguageCode;

  return (
    <div className="language-flags">
      {languages.map((lang) => {
        const FlagComponent = flagComponents[lang.code];
        return (
          <div key={lang.code} className="flag-wrapper">
            <button
              className={`flag-btn ${currentLang === lang.code ? 'active' : ''}`}
              onClick={() => handleChange(lang.code)}
            >
              <FlagComponent />
            </button>
            <span className="flag-tooltip">{lang.name}</span>
          </div>
        );
      })}
      <style>{`
        .language-flags {
          display: flex;
          gap: 8px;
          align-items: center;
        }
        .flag-wrapper {
          position: relative;
        }
        .flag-btn {
          background: var(--color-surface);
          border: 1px solid var(--color-border);
          padding: 6px 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          border-radius: 6px;
          transition: all 0.15s ease;
          opacity: 0.7;
        }
        .flag-btn:hover {
          background: var(--color-surface-hover);
          border-color: var(--color-text-muted);
          opacity: 1;
        }
        .flag-btn.active {
          background: var(--color-surface-hover);
          border-color: var(--ctp-teal, #14b8a6);
          opacity: 1;
        }
        .flag-btn svg {
          display: block;
          border-radius: 2px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }
        .flag-tooltip {
          position: absolute;
          top: calc(100% + 8px);
          left: 50%;
          transform: translateX(-50%);
          background: var(--ctp-surface0, #363a4f);
          color: var(--ctp-text, #cad3f5);
          padding: 6px 10px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          opacity: 0;
          visibility: hidden;
          transition: all 0.15s ease;
          pointer-events: none;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
          z-index: 100;
        }
        .flag-tooltip::after {
          content: '';
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          border: 5px solid transparent;
          border-bottom-color: var(--ctp-surface0, #363a4f);
        }
        .flag-wrapper:hover .flag-tooltip {
          opacity: 1;
          visibility: visible;
        }
      `}</style>
    </div>
  );
}
